// LIST
export const GET_PREVIEW = "app/ASSESSMENT/GET_PREVIEW";
export const GET_PREVIEW_SUCCESS = "app/ASSESSMENT/GET_PREVIEW_SUCCESS";
export const GET_PREVIEW_FAILURE = "app/ASSESSMENT/GET_PREVIEW_FAILURE";

export const GET_TEMPLATE_DATA = "app/ASSESSMENT/GET_TEMPLATE_DATA";
export const GET_TEMPLATE_DATA_SUCCESS =
  "app/ASSESSMENT/GET_TEMPLATE_DATA_SUCCESS";
export const GET_TEMPLATE_DATA_FAILURE =
  "app/ASSESSMENT/GET_TEMPLATE_DATA_FAILURE";

export const SAVE_TEMPLATE_DATA = "app/ASSESSMENT/SAVE_TEMPLATE_DATA";
export const SAVE_TEMPLATE_DATA_SUCCESS =
  "app/ASSESSMENT/SAVE_TEMPLATE_DATA_SUCCESS";
export const SAVE_TEMPLATE_DATA_FAILURE =
  "app/ASSESSMENT/SAVE_TEMPLATE_DATA_FAILURE";

export const UPLOAD_FILE = "app/ASSESSMENT/UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "app/ASSESSMENT/UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "app/ASSESSMENT/UPLOAD_FILE_FAILURE";

export const DELETE_FILE = "app/ASSESSMENT/DELETE_FILE";
export const DELETE_FILE_SUCCESS = "app/ASSESSMENT/DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILURE = "app/ASSESSMENT/DELETE_FILE_FAILURE";

export const SEARCH_TEMPLATES = "app/ASSESSMENT/SEARCH_TEMPLATES";
export const SEARCH_TEMPLATES_SUCCESS =
  "app/ASSESSMENT/SEARCH_TEMPLATES_SUCCESS";
export const SEARCH_TEMPLATES_FAILURE =
  "app/ASSESSMENT/SEARCH_TEMPLATES_FAILURE";

export const GET_CARE_SUMMARY = "app/ASSESSMENT/GET_CARE_SUMMARY";
export const GET_CARE_SUMMARY_SUCCESS =
  "app/ASSESSMENT/GET_CARE_SUMMARY_SUCCESS";
export const GET_CARE_SUMMARY_FAILURE =
  "app/ASSESSMENT/GET_CARE_SUMMARY_FAILURE";

export const GET_VERSION_DATA = "app/ASSESSMENT/GET_VERSION_DATA";
export const GET_VERSION_DATA_SUCCESS =
  "app/ASSESSMENT/GET_VERSION_DATA_SUCCESS";
export const GET_VERSION_DATA_FAILURE =
  "app/ASSESSMENT/GET_VERSION_DATA_FAILURE";

export const UPDATE_TEMPLATE_DATA = "app/ASSESSMENT/UPDATE_TEMPLATE_DATA";
export const UPDATE_TEMPLATE_DATA_SUCCESS =
  "app/ASSESSMENT/UPDATE_TEMPLATE_DATA_SUCCESS";
export const UPDATE_TEMPLATE_DATA_FAILURE =
  "app/ASSESSMENT/UPDATE_TEMPLATE_DATA_FAILURE";

export const SAVE_SNAPSHOT = "app/ASSESSMENT/SAVE_SNAPSHOT";
export const SAVE_SNAPSHOT_SUCCESS = "app/ASSESSMENT/SAVE_SNAPSHOT_SUCCESS";
export const SAVE_SNAPSHOT_FAILURE = "app/ASSESSMENT/SAVE_SNAPSHOT_FAILURE";

export const DELETE_VERSION = "app/ASSESSMENT/DELETE_VERSION";
export const DELETE_VERSION_SUCCESS = "app/ASSESSMENT/DELETE_VERSION_SUCCESS";
export const DELETE_VERSION_FAILURE = "app/ASSESSMENT/DELETE_VERSION_FAILURE";

export const GET_CURRENT_TEMPLATE = "app/ASSESSMENT/GET_CURRENT_TEMPLATE";
export const GET_CURRENT_TEMPLATE_SUCCESS =
  "app/ASSESSMENT/GET_CURRENT_TEMPLATE_SUCCESS";
export const GET_CURRENT_TEMPLATE_FAILURE =
  "app/ASSESSMENT/GET_CURRENT_TEMPLATE_FAILURE";

// v2 catalog-driven recording (POST /api/observations)
export const RECORD_OBSERVATION = "app/ASSESSMENT/RECORD_OBSERVATION";

export const ADD_TEMPLATE_DATA = "app/ASSESSMENT/ADD_TEMPLATE_DATA";
export const ADD_TEMPLATE_DATA_SUCCESS =
  "app/ASSESSMENT/ADD_TEMPLATE_DATA_SUCCESS";
export const ADD_TEMPLATE_DATA_FAILURE =
  "app/ASSESSMENT/ADD_TEMPLATE_DATA_FAILURE";

export const GET_REVISION = "app/ASSESSMENT/GET_REVISION";
export const GET_REVISION_SUCCESS = "app/ASSESSMENT/GET_REVISION_SUCCESS";
export const GET_REVISION_FAILURE = "app/ASSESSMENT/GET_REVISION_FAILURE";

export const VIEW_REVISION = "app/ASSESSMENT/VIEW_REVISION";
export const VIEW_REVISION_SUCCESS = "app/ASSESSMENT/VIEW_REVISION_SUCCESS";
export const VIEW_REVISION_FAILURE = "app/ASSESSMENT/VIEW_REVISION_FAILURE";

export const GET_GOVERNANCE_STATS = "app/ASSESSMENT/GET_GOVERNANCE_STATS";
export const GET_GOVERNANCE_STATS_SUCCESS =
  "app/ASSESSMENT/GET_GOVERNANCE_STATS_SUCCESS";
export const GET_GOVERNANCE_STATS_FAILURE =
  "app/ASSESSMENT/GET_GOVERNANCE_STATS_FAILURE";

export const UPDATE_PLAN_STATUS = "app/ASSESSMENT/UPDATE_PLAN_STATUS";
export const UPDATE_PLAN_STATUS_SUCCESS =
  "app/ASSESSMENT/UPDATE_PLAN_STATUS_SUCCESS";
export const UPDATE_PLAN_STATUS_FAILURE =
  "app/ASSESSMENT/UPDATE_PLAN_STATUS_FAILURE";
